import { useSportContext } from '@sorare/core/src/contexts/sport';

import { MarketHomePage } from '#src/components/market-home/MarketHomePage/index.tsx';

const MarketShop = () => {
  const { sport } = useSportContext();
  return <MarketHomePage sport={sport} />;
};

export default MarketShop;
